(function() {
  'use strict';
  moduleConfig.registerModule('eclipseApp.core', ['eclipseApp.brt']);
}());
